import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { LocalStorageService } from 'app/services/localStorage.service';
import { Loggable } from 'app/utils/logging/loggable';

import { ModalDialogData, ModalDialogComponent } from '../modal-dialog/modal-dialog.component';

export const STARTING_POINT_KEY = 'showStartingPointAtMaxModal';

@Injectable({
  providedIn: 'root',
})
export class EntryFlowService extends Loggable {
  public constructor(
    private dialog: MatDialog,
    private localStorageService: LocalStorageService,
  ) {
    super();
    this.setDisplayName('EntryFlowService');
    // Check for starting max at capacity
    this.displayStartingPointAtMaxModal();
  }

  public handleStartingPointAtMax(): void {
    this.localStorageService.store(STARTING_POINT_KEY, true);
    window.location.reload();
  }

  private displayStartingPointAtMaxModal(): void {
    const displayModal = this.localStorageService.retrieve(STARTING_POINT_KEY, (modal) => JSON.parse(modal) as boolean);
    if (displayModal) {
      const data: ModalDialogData = {
        title: 'The current starting point is at capacity',
        text: `The current starting point is at capacity. Please join at a later time.`,
        primaryButtonText: 'Okay',
      };
      this.dialog
        .open<ModalDialogComponent, ModalDialogData>(ModalDialogComponent, { data, width: '540px' })
        .afterClosed()
        // TODO: unsubscribe?
        .subscribe(() => {
          this.localStorageService.store(STARTING_POINT_KEY, false);
        });
    }
  }
}
